import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Sidebar.css';
import logoImage from '../images/logo.png';

const menuStructure = {
    profile: [
        { name: 'Thông tin liên hệ', icon: 'fa-solid fa-id-card', path: '/thong-tin-lien-he' },
        { name: 'Lý lịch khoa học', icon: 'fa-solid fa-file-lines', path: '/ly-lich-khoa-hoc' },
        { name: 'Quá trình công tác', icon: 'fa-solid fa-briefcase', path: '/qua-trinh-cong-tac' },
        { name: 'Quá trình đào tạo', icon: 'fa-solid fa-user-graduate', path: '/qua-trinh-dao-tao' },
        { name: 'Lĩnh vực nghiên cứu', icon: 'fa-solid fa-magnifying-glass', path: '/linh-vuc-nghien-cuu-ca-nhan' },
        { name: 'Chuyên ngành giảng dạy', icon: 'fa-solid fa-chalkboard-user', path: '/chuyen-nganh-giang-day-ca-nhan' },
        { name: 'Học vị - Chức danh nghề nghiệp', icon: 'fa-solid fa-book', path: '/hoc-vi-chuc-danh' },
        { name: 'Trình độ ngoại ngữ', icon: 'fa-solid fa-language', path: '/ngoai-ngu-ca-nhan' },
        { name: 'Danh hiệu - Giải thưởng', icon: 'fa-solid fa-award', path: '/danh-hieu-giai-thuong' },
        { name: 'Hướng dẫn Sau đại học', icon: 'fa-solid fa-user-pen', path: '/huong-dan-sau-dai-hoc' },
    ],
    pub: [
        { name: 'Bài báo - Tham luận', icon: 'fa-solid fa-file-invoice', path: '/bai-bao-tham-luan' },
        { name: 'Đề tài', icon: 'fa-solid fa-file', path: '/de-tai' },
        { name: 'Sách - Giáo trình', icon: 'fa-solid fa-book', path: '/sach-giao-trinh' },
        { name: 'Nội dung NCKH khác', icon: 'fa-solid fa-folder', path: '/NCKH-khac' },
    ],
    idea: [
        { name: 'Danh sách sáng kiến', icon: 'fa-solid fa-lightbulb', path: '/danh-sach-sang-kien' },
    ],
    register: [
        { name: 'Đề xuất đề tài', icon: 'fa-solid fa-pen-nib', path: '/de-xuat-de-tai' },
        { name: 'Đăng ký biên soạn', icon: 'fa-solid fa-book', path: '/dang-ky-bien-soan' },
        { name: 'Đăng ký tham dự hội nghị', icon: 'fa-regular fa-building', path: '/dang-ky-tham-du-hoi-nghi' },
        { name: 'Sinh viên NCKH', icon: 'fa-solid fa-user-graduate', path: '/sinh-vien-nckh' },
        { name: 'Hỗ trợ công bố khoa học', icon: 'fa-solid fa-clipboard', path: '/ho-tro-cong-bo-khoa-hoc' },
    ],
    scoring: [
        { name: 'Tính điểm', icon: 'fa-solid fa-calculator', path: '/tinh-diem' },
        { name: 'Kê khai giảm giờ định mức', icon: 'fa-solid fa-file-signature', path: '/ke-khai-giam-gio-dinh-muc' },
        { name: 'Giờ định mức', icon: 'fa-solid fa-clock', path: '/gio-dinh-muc' },
    ],
    userMgmt: [
        { name: 'Người dùng', icon: 'fa-solid fa-user', path: '/nguoi-dung' },
        { name: 'Cơ cấu tổ chức', icon: 'fa-solid fa-sitemap', path: '/co-cau-to-chuc' },
    ],
    sciMgmt: [
        { name: 'Bài báo - Tham luận', icon: 'fa-solid fa-file-invoice', path: '/quan-ly-bai-bao' },
        { name: 'Đề tài', icon: 'fa-solid fa-file', path: '/quan-ly-de-tai' },
        { name: 'Sách - Giáo trình', icon: 'fa-solid fa-book', path: '/quan-ly-sach-giao-trinh' },
        { name: 'Nội dung NCKH Khác', icon: 'fa-solid fa-folder-open', path: '/quan-ly-noi-dung-NCKH-khac' },
        { name: 'Quản lý tạp chí', icon: 'fa-solid fa-rss', path: '/quan-ly-tap-chi' },
        { name: 'Quản lý điểm', icon: 'fa-solid fa-star', path: '/quan-ly-diem' },
        { name: 'Quản lý kê khai giảm giờ', icon: 'fa-solid fa-clock-rotate-left', path: '/quan-ly-ke-khai-giam-gio' },
        { name: 'Quản lý giờ định mức', icon: 'fa-solid fa-business-time', path: '/quan-ly-gio-dinh-muc' },
    ],
    regMgmt: [
        { name: 'Đề xuất đề tài', icon: 'fa-solid fa-file-pen', path: '/quan-ly-de-xuat-de-tai' },
        { name: 'Đăng ký biên soạn', icon: 'fa-solid fa-book-journal-whills', path: '/quan-ly-dang-ky-bien-soan' },
        { name: 'Đăng ký tham dự hội nghị', icon: 'fa-solid fa-hotel', path: '/quan-ly-dang-ky-tham-du-hoi-nghi' },
        { name: 'Sinh viên NCKH', icon: 'fa-solid fa-graduation-cap', path: '/quan-ly-sinh-vien-nckh' },
        { name: 'Hỗ trợ công bố khoa học', icon: 'fa-solid fa-medal', path: '/quan-ly-ho-tro-cong-bo-khoa-hoc' },
    ],
    qlSangKien: [
        { name: 'Danh sách sáng kiến', icon: 'fa-solid fa-lightbulb', path: '/quan-ly-sang-kien' },
    ],
    report: [
        { name: 'Thống kê nguồn nhân lực', icon: 'fa-solid fa-chart-pie', path: '/thong-ke-nhan-luc' },
        { name: 'Thống kê bài báo theo giảng viên', icon: 'fa-solid fa-chart-column', path: '/thong-ke-bai-bao-giang-vien' },
        { name: 'Thống kê bài báo theo loại', icon: 'fa-solid fa-chart-area', path: '/thong-ke-bai-bao-loai' },
        { name: 'Thống kê bài báo theo đơn vị', icon: 'fa-solid fa-sitemap', path: '/thong-ke-bai-bao-don-vi' },
        { name: 'Thống kê đề xuất theo đơn vị', icon: 'fa-solid fa-chart-line', path: '/thong-ke-de-xuat-don-vi' },
        { name: 'Thống kê đề xuất theo cá nhân', icon: 'fa-solid fa-chart-simple', path: '/thong-ke-de-xuat-ca-nhan' },
    ],
    category: [
        { name: 'Cơ chế tính điểm', icon: 'fa-solid fa-sliders', path: '/quan-ly-co-che-tinh-diem' },
        { name: 'Cấp khen thưởng', icon: 'fa-solid fa-medal', path: '/cap-khen-thuong' },
        { name: 'Quốc gia', icon: 'fa-solid fa-flag', path: '/quoc-gia' },
        { name: 'Ngoại ngữ', icon: 'fa-solid fa-language', path: '/ngoai-ngu' },
        { name: 'Trình độ', icon: 'fa-solid fa-layer-group', path: '/trinh-do' },
        { name: 'Lĩnh vực nghiên cứu', icon: 'fa-solid fa-microscope', path: '/linh-vuc-nghien-cuu' },
        { name: 'Loại khen thưởng', icon: 'fa-solid fa-award', path: '/loai-khen-thuong' },
        { name: 'Chức danh', icon: 'fa-solid fa-user-tie', path: '/chuc-danh' },
        { name: 'Loại công trình', icon: 'fa-solid fa-folder-tree', path: '/loai-cong-trinh' },
        { name: 'Cấp đề tài', icon: 'fa-solid fa-tags', path: '/cap-de-tai' },
        { name: 'Nội dung NCKH khác', icon: 'fa-solid fa-flask', path: '/noi-dung-NCKH-khac' },
        { name: 'Loại tạp chí', icon: 'fa-solid fa-newspaper', path: '/loai-tap-chi' },
        { name: 'Giờ chuẩn', icon: 'fa-solid fa-clock', path: '/gio-chuan' },
        { name: 'Giảm trừ NCKH', icon: 'fa-solid fa-minus-circle', path: '/giam-tru-nckh' },
        { name: 'Chuyên ngành giảng dạy', icon: 'fa-solid fa-chalkboard-user', path: '/chuyen-nganh-giang-day' },
    ]
};

const Sidebar = ({ isCollapsed, setIsCollapsed, isMobile }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || {});
    const navigate = useNavigate();
    const location = useLocation();

    const [openMenus, setOpenMenus] = useState({});
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const isExpanded = !isCollapsed || isHovered;

    const { isSystemAdmin, isScientificManager } = useMemo(() => {
        const roleName = (user?.RoleName || '').toLowerCase();
        const roleId = user?.RoleId;
        const isDel = user?.IsDelegatedAdmin === true;
        const sysAdmin = roleId === 1 || roleName === 'quản trị viên';
        const sciManager = sysAdmin || roleId === 11 || roleName.includes('quản lý khoa');

        return { isSystemAdmin: sysAdmin, isScientificManager: sciManager };
    }, [user]);

    useEffect(() => {
        if (!isScientificManager && location.pathname === '/') {
            navigate('/thong-tin-lien-he', { replace: true });
        }
    }, [isScientificManager, location.pathname, navigate]);

    useEffect(() => {
        const handleSyncUser = () => {
            const updatedUser = JSON.parse(localStorage.getItem('user')) || {};
            setUser(updatedUser);
        };
        window.addEventListener('storage', handleSyncUser);
        return () => window.removeEventListener('storage', handleSyncUser);
    }, []);

    useEffect(() => {
        const currentPath = location.pathname;
        for (const [key, subItems] of Object.entries(menuStructure)) {
            if (subItems.some(item => item.path === currentPath)) {
                setOpenMenus(prev => ({ ...prev, [key]: true }));
                break;
            }
        }
    }, [location.pathname]);

    const toggleSubMenu = (menuKey) => {
        if (!isExpanded) return;
        setOpenMenus(prev => ({ ...prev, [menuKey]: !prev[menuKey] }));
    };

    const isMenuActive = (menuKey) => {
        return menuStructure[menuKey].some(item => item.path === location.pathname);
    };

    const renderSubMenu = (items) => {
        if (!isExpanded) return null;
        return (
            <ul className="sub-menu">
                {items.map((item, index) => (
                    <li
                        key={index}
                        className={`sub-menu-item ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (item.path) {
                                navigate(item.path);
                                if (isMobile) setIsCollapsed(true);
                            }
                        }}
                    >
                        <i className={`${item.icon} sub-icon`}></i> {item.name}
                    </li>
                ))}
            </ul>
        );
    };

    let sidebarClass = `sidebar ${isHovered ? 'sidebar-hovered' : ''}`;
    if (isMobile) {
        sidebarClass += isCollapsed ? ' mobile-closed' : ' mobile-open';
    }

    return (
        <div className={sidebarClass}>

            <div className="sidebar-header-wrapper">
                {!isCollapsed && (
                    <div className="sidebar-logo" onClick={() => navigate(isScientificManager ? '/' : '/thong-tin-lien-he')} style={{ cursor: 'pointer' }}>
                        <img src={logoImage} alt="DUE Logo" className="sidebar-logo-img" />
                        <span className="logo-text" style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                            DUE NCKH
                        </span>
                    </div>
                )}

                <div
                    className="sidebar-toggle-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsCollapsed(!isCollapsed);
                    }}
                >
                    <i className={`fa-solid ${!isCollapsed ? 'fa-bars' : 'fa-ellipsis-vertical'}`}></i>
                </div>
            </div>

            <div
                className="sidebar-nav-content"
                style={{ paddingBottom: '20%' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                    <div
                        className="user-info"
                        onClick={() => isExpanded && setIsUserMenuOpen(!isUserMenuOpen)}
                        style={{ cursor: isExpanded ? 'pointer' : 'default' }}
                    >
                        <div className="avatar">
                            {user.AvatarUrl ? (
                                <img src={user.AvatarUrl} alt="Avatar" />
                            ) : (
                                user.FullName?.charAt(0) || user.Username?.charAt(0) || 'U'
                            )}
                        </div>

                        {isExpanded && (
                            <div style={{ marginLeft: '12px', overflow: 'hidden', flex: 1 }}>
                                <div style={{ fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span className="text-truncate">{user.FullName || user.Username || 'Người dùng'}</span>
                                    <i className={`fa-solid fa-caret-down arrow ${isUserMenuOpen ? 'open' : ''}`} style={{ margin: 0 }}></i>
                                </div>
                                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)' }} className="text-truncate">
                                    {user.RoleName}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className={`user-dropdown-wrapper ${(isExpanded && isUserMenuOpen) ? 'open' : ''}`}>
                        <div className="user-dropdown-inner">
                            <div
                                className={`user-dropdown-item ${location.pathname === '/thong-tin-lien-he' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate('/thong-tin-lien-he');
                                    if (isMobile) setIsCollapsed(true);
                                }}
                            >
                                Hồ sơ của tôi
                            </div>
                            <div
                                className={`user-dropdown-item ${location.pathname === '/lich-su-hoat-dong' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate('/lich-su-hoat-dong');
                                    if (isMobile) setIsCollapsed(true);
                                }}
                            >
                                Lịch sử hoạt động
                            </div>
                        </div>
                    </div>
                </div>

                <ul className="menu-list">
                    {isScientificManager && (
                        <li className={`menu-item ${location.pathname === '/' ? 'active' : ''}`} onClick={() => {
                            navigate('/');
                            if (isMobile) setIsCollapsed(true);
                        }}>
                            <i className="fa-solid fa-chart-pie menu-icon"></i>
                            {isExpanded && <span>Tổng quan</span>}
                        </li>
                    )}

                    {Object.keys(menuStructure).map((key) => {
                        if ((key === 'category' || key === 'userMgmt') && !isSystemAdmin) return null;

                        const isSciManagerMenu = ['sciMgmt', 'regMgmt', 'qlSangKien', 'report'].includes(key);
                        if (isSciManagerMenu && !isScientificManager) return null;

                        const labels = {
                            profile: 'Lý lịch khoa học',
                            pub: 'Công bố khoa học',
                            idea: 'Sáng kiến',
                            register: 'Đề xuất - Đăng ký',
                            scoring: 'Tính điểm khoa học',
                            userMgmt: 'Quản lý người dùng',
                            sciMgmt: 'Quản lý khoa học',
                            regMgmt: 'Quản lý đề xuất - đăng ký',
                            qlSangKien: 'Quản lý sáng kiến',
                            report: 'Thống kê - Báo cáo',
                            category: 'Quản lý danh mục'
                        };

                        const icons = {
                            profile: 'fa-address-card',
                            pub: 'fa-file-alt',
                            idea: 'fa-lightbulb',
                            register: 'fa-pen-nib',
                            scoring: 'fa-calculator',
                            userMgmt: 'fa-users-gear',
                            sciMgmt: 'fa-flask-vial',
                            regMgmt: 'fa-book-open-reader',
                            qlSangKien: 'fa-vial-circle-check',
                            report: 'fa-chart-line',
                            category: 'fa-gear'
                        };

                        return (
                            <React.Fragment key={key}>
                                <li
                                    className={`menu-item has-submenu ${isMenuActive(key) ? 'active' : ''}`}
                                    onClick={() => toggleSubMenu(key)}
                                >
                                    <i className={`fa-solid ${icons[key]} menu-icon`}></i>
                                    {isExpanded && <span>{labels[key]}</span>}
                                    {isExpanded && <i className={`fa-solid fa-chevron-down arrow ${openMenus[key] ? 'open' : ''}`}></i>}
                                </li>
                                {openMenus[key] && renderSubMenu(menuStructure[key])}
                            </React.Fragment>
                        );
                    })}

                    {isSystemAdmin && (
                        <li
                            className={`menu-item ${location.pathname === '/dong-bo-tdkt' ? 'active' : ''}`}
                            onClick={() => {
                                navigate('/dong-bo-tdkt');
                                if (isMobile) setIsCollapsed(true);
                            }}
                        >
                            <i className="fa-solid fa-cloud-arrow-up menu-icon"></i>
                            {isExpanded && <span>Đồng bộ Thi đua - Khen thưởng</span>}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;